import Dayjs from 'dayjs'

export default {
  state: {
    alarms: [],
    newAlarmCount: 0
  },
  getters: {
    'alarm:alarms': state => {
      let alarms = [...state.alarms].splice(0, 99)
      return alarms
    },
    'alarm:newAlarmCount': state => state.newAlarmCount
  },
  actions: {
    alarmSocketConnect ({ state, commit, dispatch }) {
      let self = this
      dispatch('subscribe', {
        url: '/fdc/mts/alarm',
        callback: function (tick) {
          let tickObj = JSON.parse(tick.body)
          self.dispatch('alarmAppend', tickObj)
        }
      })
    },
    alarmAppend ({ commit, state }, tickObj) {
      commit('addAlarm', {
        received: Dayjs().format('YYYY-MM-DD HH:mm:ss'),
        fab: tickObj.fab,
        eqpId: tickObj.eqpId,
        moduleId: tickObj.moduleId,
        open: false,
        data: tickObj
      })
      commit('setNewAlarmCount', state.newAlarmCount + 1)
    },
    'alarm:flushNewAlarmCount' ({ commit }) {
      commit('setNewAlarmCount', 0)
    }
  },
  mutations: {
    addAlarm (state, payload) {
      if (state.alarms.length > 999) state.alarms.pop()
      state.alarms.unshift(payload)
    },
    setNewAlarmCount (state, payload) {
      state.newAlarmCount = payload
    }

  }
}
